<script>
    import { mapActions} from 'vuex'
    export default{
        data(){
            return {

            }
        },
        methods:{
            ...mapActions({
                logout: 'user/logout'
            }),
        },
        computed: {
        },
    }
</script>

<template>
    <div class="mag-header-exit" @click="logout" title="Выйти">
        <i class="mag-icon-nav-top-exit"></i>
    </div>
</template>

<style lang="scss">
    .mag-header-exit{
        width: 40px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        color: #7bc28e;
        font-size: 20px;
    }
</style>
